import pdfMake from "pdfmake/build/pdfmake";
import vfsFonts from "pdfmake/build/vfs_fonts";

var viewActions = require("store/view.actions");
var unirest = require("unirest");
const API = require("Api");

async function getReportComponents(token, calendarID, personaID, reportID) {
  // const res =  await unirest.get('http://0.0.0.0:3005/dev/' + personaID + "/" + reportID )

  const res = await unirest
    .get(API.V2 + API.REPORTS + personaID + "/" + reportID)
    .headers({
      Authorization: "Bearer " + token,
      crrntcal: calendarID,
      "Content-Type": "application/json",
    });
  if (res.error) console.log(res.error);
  let list = res.body;
  return list;
}

export async function getReport(token, calendarID, personaID, reportID) {
  calendarID = "20270000-5026-4B33-9EAA-000000002027";

  viewActions.notification({
    message:
      "El documento ya se esta generando, luego de unos segundos iniciará la descarga.",
    title: "Descarga",
    type: "success",
  });

  getReportComponents(token, calendarID, personaID, reportID).then((json) => {
    const { vfs } = vfsFonts.pdfMake;
    pdfMake.vfs = vfs;

    const documentDefinition = {
      pageSize: "A4",
      pageOrientation: "portrait",
      pageMargins: [40, 40, 40, 60],

      header: json.pageHeader,
      content: [json.body],
      footer: json.pageFooter,
      styles: json.styles,
    };
    pdfMake.createPdf(documentDefinition).open();
  });
}
